export default __webpack_public_path__ + "static/media/sampleAnnoucement.4b50b48b.jpg";